/**
 * Copyright schukai GmbH and contributors 2023. All Rights Reserved.
 * Node module: @schukai/monster
 * This file is licensed under the AGPLv3 License.
 * License text available at https://www.gnu.org/licenses/agpl-3.0.en.html
 */

import { Base } from "./base.mjs";
import { Observer } from "./observer.mjs";
import { validateInstance } from "./validate.mjs";

export { ObserverList };

/**
 * With the help of the ObserverList class, observer can be managed.
 *
 * @license AGPLv3
 * @since 1.0.0
 * @copyright schukai GmbH
 * @memberOf Monster.Types
 */
class ObserverList extends Base {
	/**
	 *
	 */
	constructor() {
		super();
		this.observers = [];
	}

	/**
	 *
	 * @param {Observer} observer
	 * @return {ObserverList}
	 * @throws {TypeError} value is not an instance of Observer
	 */
	attach(observer) {
		validateInstance(observer, Observer);

		this.observers.push(observer);
		return this;
	}

	/**
	 *
	 * @param {Observer} observer
	 * @return {ObserverList}
	 * @throws {TypeError} value is not an instance of Observer
	 */
	detach(observer) {
		validateInstance(observer, Observer);

		var i = 0;
		var l = this.observers.length;
		for (; i < l; i++) {
			if (this.observers[i] === observer) {
				this.observers.splice(i, 1);
			}
		}

		return this;
	}

	/**
	 *
	 * @param {Observer} observer
	 * @return {boolean}
	 * @throws {TypeError} value is not an instance of Observer
	 */
	contains(observer) {
		validateInstance(observer, Observer);
		var i = 0;
		var l = this.observers.length;
		for (; i < l; i++) {
			if (this.observers[i] === observer) {
				return true;
			}
		}
		return false;
	}

	/**
	 *
	 * @param subject
	 * @return {Promise}
	 */
	notify(subject) {
		const pomises = [];

		let i = 0;
		const l = this.observers.length;
		for (; i < l; i++) {
			pomises.push(this.observers[i].update(subject));
		}

		return Promise.all(pomises);
	}
}
